import React from "react";
import { ASSESSMENT_FIELD_LABELS } from "../../utils/assessmentAdminFieldConfig";

/**
 * Diligent Notes textarea / read-only block for admin assessment detail.
 */
export default function AssessmentAdminDiligentNotes({
  updateActive,
  register,
  setValue,
  readValue,
}) {
  return (
    <div className="px-0 py-4">
      <div>
        <label
          htmlFor="diligentNotes"
          className="block text-sm/6 font-medium text-gray-900"
        >
          {ASSESSMENT_FIELD_LABELS.diligentNotes}
        </label>
        <div className="mt-2">
          {updateActive ? (
            <textarea
              id="diligentNotes"
              name="diligentNotes"
              rows={4}
              {...register("diligentNotes", {
                onChange: (e) => {
                  setValue("diligentNotes", e.target.value, {
                    shouldValidate: true,
                  });
                },
              })}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              placeholder="Enter Diligent notes..."
            />
          ) : (
            <div className="block w-full rounded-md bg-gray-50 px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 sm:text-sm/6 min-h-[100px] whitespace-pre-wrap">
              {readValue || "-"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
